import { Component, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { forkJoin, Observable } from 'rxjs';


import { AppEmpresas } from './../../../core/models/appEmpresas.model';
import { AppEmpresasService } from './../../../core/services/appEmpresasService.service';
import { AppSmtp } from '../../../core/models/appSmtp.model';
import { AppSmtpService } from '../../../core/services/appSmtpService.service';
import { AppSeccion } from '../../../core/models/appSeccion.model';
import { AppDocumentos } from '../../../core/models/appDocumentos.model';
import { AppSeccionesService } from '../../../core/services/appSeccionesService.service';
import { AppImagenesService } from '../../../core/services/appImagenes.service';


import { MessageDialog } from '../../../components/message-dialog/messageDialog';
import { EditFormBase } from '../../../core/helper/EditFormBase';
import { SessionHelper } from '../../../core/helper/sessionHelper';
import { AppConfiguracionEntornoService } from '../../../core/services/appConfiguracionEntornoService.service';
import { AppDocumentosService } from '../../../core/services/appDocumentos.service';

import { LicenseCheckerService } from '../../../core/helper/licenseChecker';
import { Configuration } from '../../../core/configuration/configuration';
import { LivesSessionHelper } from '../../../core/helper/livesSessionHelper';



interface ISection {
  id: string;
  area: string;
  validator: string;
  validatorName: string;
  validatorPosition: string;
  delegateResponsibleAllow: boolean;
  delegateResponsible: string;
  delegateResponsibleName: string;
  delegateResponsiblePosition: string;
  dualResponsibleAllow: boolean;
  dualResponsible: string;
  dualResponsibleName: string;
  dualResponsiblePosition: string;
  children?: ISection[];
  isOpen?: boolean;
}

@Component({
  selector: 'app-empresas-detail',
  templateUrl: './empresas-detail.component.html',
  styleUrls: ['./empresas-detail.component.scss'],
  providers: [AppConfiguracionEntornoService, AppEmpresasService, AppSmtpService, AppSeccionesService, AppImagenesService, AppDocumentosService, LicenseCheckerService]
})
export class EmpresasDetailComponent extends EditFormBase<AppEmpresas, string> implements OnInit, OnChanges {

  //Roles
  isAdmin: boolean = false;

  //Licencia HostelHR
  hostelLicence: boolean;
  livesLicence: boolean;
  conectiaLicence: boolean;
  myReportinLicense: boolean;

  // Propiedades del panel contenedor
  panelIcon = 'business'; // Material icon
  panelTitle = 'Nueva empresa';
  panelTitleTwo = 'Editar empresa';
  panelDescription = 'Crear empresa';
  panelDescriptionTwo = 'Editar empresa';


  //variables generales
  companyFormEdit = false;
  sectionsFormEdit = false;
  smtpFormEdit = false;



  originalModelCompany: AppEmpresas;
  originalModelSections: ISection;
  originalModelSmtp: AppSmtp;


  //empresa
  companyId: string;
  enabled: boolean;
  myReportin: string;
  myReportinValid: boolean = true;
  myReportinRegex: RegExp = /^https:\/\/(app|apptest)\.myreportin\.com\/public\/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
  pushAccept: string;
  pushAcceptValid: boolean = true;
  pushReject: string;
  pushRejectValid: boolean = true;
  mailAccept: string;
  mailAcceptValid: boolean = true;
  mailReject: string;
  mailRejectValid: boolean = true;
  base64ImageData: string = '';
  base64StampData: string = '';
  loading: boolean = false;
  customButtonImageValid: boolean = true;
  customButtonNameValid: boolean = true;
  customButtonAndroidUrlValid: boolean = true;
  customButtonIosUrlValid: boolean = true;
  customButtonAndroidUrlRegex: RegExp = /^(https?:\/\/[^\s/$.?#].[^\s]*|https:\/\/play\.google\.com\/store\/apps\/details\?id=[a-zA-Z0-9._-]+)$/;
  customButtonIosUrlRegex: RegExp = /^(https?:\/\/[^\s/$.?#].[^\s]*|https:\/\/apps\.apple\.com\/[a-z]{2}\/app\/[a-zA-Z0-9._-]+\/id\d+)$/;
  showLoadingInnuvaSpinner: boolean = false;


  //anticipos y bolsa de vacaciones
  holidayBagValidatorAllowed: boolean;
  advancesValidatorAllowed: boolean;
  advanceInitialDayValid: boolean = true;
  advanceLimitDayValid: boolean = true;
  advanceLimitAmountValid: boolean = true;


  //organigrama / secciones
  showLoadingSpinner: boolean = false;
  showOrgChart: boolean = true;
  lastUpdateDate: string = '';
  sections: AppSeccion[];
  orgData: ISection[];
  section: AppSeccion;


  sectionModel: {};
  isSectionSelected: boolean = false
  isCompanySelectedDelegatedValidatorReadOnly: boolean = true;
  isCompanySelectedDoubleValidatorReadOnly: boolean = true;

  //smtp
  smtpModel: AppSmtp;
  showPassword: boolean = false;
  smtportPortValid: boolean = true;
  outServerPortValid: boolean = true;
  outServerValid: boolean = true;
  userValid: boolean = true;
  passwordValid: boolean = true;
  checkSmtpButtonEnabled: boolean = true;
  checkSmtpChecked: boolean = true;

  constructor(
    _route: ActivatedRoute,
    _modelService: AppEmpresasService,
    _messageDialog: MessageDialog,
    protected _session: SessionHelper,
    _router: Router,
    _location: Location,
    private route: ActivatedRoute,

    private _environmentService: AppConfiguracionEntornoService,
    private _companyService: AppEmpresasService,
    private _sectionsService: AppSeccionesService,
    private _imagesService: AppImagenesService,
    private _smtpServerService: AppSmtpService,
    private _documentosService: AppDocumentosService,
    private _licenceCheckerService: LicenseCheckerService ,
    private _livesSession: LivesSessionHelper

  ) {
    super(_modelService, _messageDialog, _route, _router, _location, AppEmpresas);

    this.isAdmin = this._session.User?.Roles?.includes(Configuration.rolAdministrador) || false;
    this.model = new AppEmpresas();
    this.sectionModel = {};
    this.section = new AppSeccion();
    this.smtpModel = new AppSmtp();
    this.isNew = this.checkIsNew();
    //inicializo para evitar errores
    this.model.companyImageData = { name: '', mimeType: '', base64: '', base64FullData: '' };
    this.model.companyStampData = { name: '', mimeType: '', base64: '', base64FullData: '' };

  }


  /* IMAGENES */
  private loadImage(imageId: string): Observable<any> {
    this.model.image = imageId;
    return this._imagesService.getModel(imageId);
  }

  private loadStamp(imageId: string): Observable<any> {
    this.model.stamp = imageId;
    return this._imagesService.getModel(imageId);
  }

  private assignImageData(targetData: any, sourceData: any) {
    if (sourceData && targetData) {
      targetData.image = sourceData.image1 ?? targetData.image;
      targetData.name = sourceData.name;
      targetData.mimeType = sourceData.mimeType;
      targetData.base64 = sourceData.imageData;
      targetData.base64FullData = `data:${sourceData.mimeType};base64,${sourceData.imageData}`;
    }
  }

  /* CAMBIOS */
  //función para detectar solo los elementos que cambian y devolverlos

  private isEqual(value1: any, value2: any): boolean {
    if (typeof value1 !== 'object' && typeof value2 !== 'object') {
      // Si ambos valores no son objetos, se comapran exhaustivamente
      return value1 === value2;
    }

    if (value1 === null || value2 === null || typeof value1 !== 'object' || typeof value2 !== 'object') {
      return false;
    }
    const keys1 = Object.keys(value1);
    const keys2 = Object.keys(value2);
    if (keys1.length !== keys2.length) {
      // Si tienen diferente numero de propiedades son diferentes
      return false;
    }
    for (const key of keys1) {
      // Comparar cada propiedad
      if (!keys2.includes(key) || !this.isEqual(value1[key], value2[key])) {
        return false;
      }
    }
    // Si todas las propiedades son iguales, entonces los son iguales
    return true;
  }


  private getChangesCompany(): Partial<AppEmpresas> {
    const changes: Partial<AppEmpresas> = {};
    for (const key in this.originalModelCompany, this.model) {
      if (!this.isEqual(this.originalModelCompany[key], this.model[key])) {
        changes[key] = this.model[key];
      }
    }

    return changes;
  }

  private getChangesSections(): Partial<AppSeccion> {
    const changes: Partial<AppSeccion> = {};
    for (const key in this.originalModelSections) {

      //corrección error habilitar botón de guardado porque los allows pueden venir como string o boolean
      if (typeof (this.originalModelSections[key]) == 'boolean') {

        //si lo es lo comparo como strings
        if (!this.isEqual(this.originalModelSections[key].toString(), this.section[key]) && this.section[key] != null) {
          //Si el valor viene como string se lo asigno en booleano a changes
          if (this.section[key] === 'true' || this.section[key] === 'false') {
            changes[key] = this.section[key] === 'true';
          } else {
            changes[key] = this.section[key];
          }
        }

      } else {
        if (!this.isEqual(this.originalModelSections[key], this.section[key]) && this.section[key] != null) {
          changes[key] = this.section[key];
        }
      }
    }
    return changes;
  }

  private getChangesSmtpServer(): Partial<AppSmtp> {
    const changes: Partial<AppSmtp> = {};

    // Verifica si el objeto original tiene propiedades
    if (Object.keys(this.originalModelSmtp).length === 0) {
      // Si no tiene propiedades, copia todas las propiedades del objeto smtpModel
      for (const key in this.smtpModel) {
        changes[key] = this.smtpModel[key];
      }
    } else {
      // Si el objeto original tiene propiedades, compara las diferencias
      for (const key in this.originalModelSmtp) {
        if (!this.isEqual(this.originalModelSmtp[key], this.smtpModel[key]) && this.smtpModel[key] !== null) {
          changes[key] = this.smtpModel[key];
        }
      }
    }

    return changes;
  }


  /* INICIO */
  private getValidatorsArray(validatorsInfo: any[]): string[] {

    const hostelUserIds = validatorsInfo.map(validator => validator.hostelUserId);
    return hostelUserIds;
  }



  ngOnInit(): void {
    this.hostelLicence = this._licenceCheckerService.checkLicense("hostelHR");
    this.livesLicence = this._licenceCheckerService.checkLicense("livesHR");
    this.conectiaLicence = this._licenceCheckerService.checkLicense("conectia");
    this.myReportinLicense = this._licenceCheckerService.checkLicense("myreportin");

    if (!this.isNew) {
      this.companyId = this.getUrlId();
      let companyData: any;
      let smtpServerData: any;

      this._modelService.getModel(this.companyId).subscribe((response: any) => {

        this.smtpModel = new AppSmtp;
        this.originalModelSmtp = new AppSmtp;
        if (response) {
          companyData = response[0]
          this.model.company1 = this.companyId;
          this.model.companyCode = companyData.companyCode;
          this.model.myreportin = companyData.myreportin;
          this.model.name = companyData.name;
          this.model.identifierNumber = companyData.identifierNumber;
          this.model.holidayBagAllowed = companyData.holidayBagAllowed;
          this.holidayBagValidatorAllowed = companyData.holidayBagAllowed;
          this.model.sendAutoInvite = companyData.sendAutoInvite;
          this.model.netUsers = this.getValidatorsArray(companyData.netUsers);
          this.model.hrValidators = this.getValidatorsArray(companyData.hrValidators);
          this.model.holidayBagValidator = companyData.holidayBagValidator;
          this.model.appId = companyData.appId;
          this.model.pushAcceptText = companyData.pushAcceptText;
          this.model.pushDenyText = companyData.pushDenyText;
          this.model.mailAcceptText = companyData.mailAcceptText;
          this.model.mailDenyText = companyData.mailDenyText;
          /* this.model.seniorityCompanyDate = companyData.seniorityCompanyDate; */
          if (companyData.smtpServerData) {
            this.checkSmtpChecked = false; //si vienen datos no se usa el por defecto 
            this.smtpModel = companyData.smtpServerData;
            this.originalModelSmtp = JSON.parse(JSON.stringify(companyData.smtpServerData));
          } else {
            this.checkSmtpChecked = true
          }

          this.model.customRedirection = companyData.customRedirection;
          this.assignImageData(this.model.companyImageData, companyData.image);
          this.assignImageData(this.model.companyStampData, companyData.stamp);

          this.originalModelCompany = JSON.parse(JSON.stringify(this.model));

          this.model.advanceAllowed = companyData.advanceAllowed
          this.advancesValidatorAllowed = companyData.advanceAllowed
          this.model.advanceLimitAmount = companyData.advanceLimitAmount
          this.model.advanceInitialDay = companyData.advanceInitialDay
          this.model.advanceLimitDay = companyData.advanceLimitDay
          this.model.advanceValidator = companyData.advanceValidator
          this.model.advanceValidatorData = companyData.advanceValidatorData
        }

        if (this.conectiaLicence) {
          this._companyService.checkSharingOrg(this.model.companyCode).subscribe(
            result => {
              switch (result.responseCode) {
                case 'COMPANIES_SHARING_ORGANIGRAM':
                  // Se muestra popup error  
                  const formattedList = result.data
                    .map((item: any) => `${item.companyName}(${item.companyCode})`)
                    .join(', ');

                  this._messageDialog.ShowAlert(
                    `Las siguientes empresas comparten organigrama y no están parametrizadas. Es imprescindible configurarlas para el correcto funcionamiento: ${formattedList}`,
                    'Error en la empresa'
                  );
                  break;

                case 'NOT_COMPANY_SHARE_ORG_FOUND':
                  // No se muestra nada
                  break;
                case 'ALL_COMPANIES_ALREADY_PARAMETRIZED':
                  // No se muestra nada
                  break;

                default:
                  console.error(result)
                  break;
              }


            },
            error => {
              switch (error.responseCode) {
                case 'NOT_ORG_FOUND':
                  // Si tiene Lives se muestra popup aviso
                 if(this.livesLicence) {
                  this._messageDialog.ShowAlert(
                    'La empresa no tiene configurado un organigrama. Es imprescindible configurarlo para el correcto funcionamiento',
                    'Error en la empresa'
                  );
                }
                  break;

                case 'UNEXPECTED_ERROR':
                  console.warn(error)
                  break;

                default:
                  console.error(error)
                  break;
              }

            }
          )
        }

      },
        error => {
          console.error('Error fetching the model:', error);
        }
      );

      this.updateAndShowLoadingSpinner({ firstLoad: true });
    } else {
      let environmentID = this._livesSession.EnvironmentId;

      this.model.companyCode = null;
      this.model.appId = null;

      this._environmentService.getModel(environmentID).subscribe(
        (response: any) => {

          this.model.pushAcceptText = response.pushAcceptText;
          this.model.pushDenyText = response.pushDenyText;
          this.model.mailAcceptText = response.mailAcceptText;
          this.model.mailDenyText = response.mailDenyText;
          /* this.model.seniorityCompanyDate = true; */
          this.model.holidayBagAllowed = this.hostelLicence ? true : false;
          this.holidayBagValidatorAllowed = true;
          this.model.sendAutoInvite = true;
          this.model.advanceAllowed = true;
          this.advancesValidatorAllowed = true;

          this.model.customRedirection = response.customRedirection;

          let imageForkJoin = this.loadCompanyAssets(response.image, response.stamp)

          imageForkJoin.subscribe(results => {
            // results[0] es la respuesta de loadImage, results[1] es la respuesta de loadStamp

            if (results[0]) {
              this.assignImageData(this.model.companyImageData, results[0]);
            }
            if (results[1]) {
              this.assignImageData(this.model.companyStampData, results[1]);
            }
          })

        },
        error => {
          console.error('Error al obtener el modelo:', error);
        })
    }

  }

  checkIsNew(): boolean {
    if (this._router.url.endsWith('new')) {
      return true
    } else {
      return false;
    }
  }


  getUrlId(): string {
    var url = this._router.url.split('/');
    return url[url.length - 1]
  }

  loadCompanyAssets(imageUrl: string, stampUrl: string): Observable<any[]> {
    const imageObservable = this.loadImage(imageUrl);
    const stampObservable = this.loadStamp(stampUrl);

    return forkJoin([imageObservable, stampObservable]);
  }



  /* DATOS DE EMPRESA */

  /* HANDLERS */
  handleImageSelected(base64Image: any) {
    this.assignImageData(this.model.companyImageData, base64Image);
    this.checkFieldsNotEmptyCompany()
  }

  handleStampSelected(base64Stamp: any) {
    this.assignImageData(this.model.companyStampData, base64Stamp);
    this.checkFieldsNotEmptyCompany()
  }

  handleVisibleCustomButtonChange(event: any): void {
    if (this.model.customRedirection) {
      this.model.customRedirection.showButtonRedirection = event.value;
    }
  }

  handleCustomButtonImageChange(event: any): void {
    this.model.customRedirection.image = event.imageData;
    this.checkFieldsNotEmptyCompany();
  }

  handleCustomButtonNameChange(event: any): void {
    this.model.customRedirection.name = event;
    this.checkFieldsNotEmptyCompany();
  }

  handleCustomButtonAndroidUrlChange(event: any): void {
    this.model.customRedirection.androidUrl = event;
    this.checkFieldsNotEmptyCompany();
  }

  handleVisibleCustomIosUrlChange(event: any): void {
    this.model.customRedirection.iosUrl = event;
    this.checkFieldsNotEmptyCompany();
  }


  /* VALIDACIONES */
  validateMyreportin() {
    if (this.model.myreportin && this.model.myreportin.length > 0 && this.model.myreportin != null) {
      this.myReportinValid = this.myReportinRegex.test(this.model.myreportin);
      return this.myReportinValid
    } else {
      this.myReportinValid = true
      return true
    }
  }

  validateAdvanceInitialDay(value: number): boolean {
    // Validación básica de rango para el día inicial
    if (value >= 1 && value <= 31) {
      this.advanceInitialDayValid = true;
    } else {
      this.advanceInitialDayValid = false;
    }

    // Validar que el día inicial no sea mayor al día límite, si existe un valor
    if (this.model.advanceLimitDay && value > this.model.advanceLimitDay) {
      this.advanceInitialDayValid = false;
    }


    return this.advanceInitialDayValid;
  }

  validateAdvanceLimitDay(value: number): boolean {
    // Validación básica de rango para el día límite
    if (value >= 1 && value <= 31) {
      this.advanceLimitDayValid = true;
    } else {
      this.advanceLimitDayValid = false;
    }

    // Validar que el día límite no sea menor al día inicial, si existe un valor
    if (this.model.advanceInitialDay && value < this.model.advanceInitialDay) {
      this.advanceLimitDayValid = false;
    }


    return this.advanceLimitDayValid;
  }

  // Función para validar ambos campos juntos sin recursión
  validateBothAdvanceFields(): boolean {
    // Primero validamos el día inicial
    let isInitialDayValid = this.validateAdvanceInitialDay(Number(this.model.advanceInitialDay));

    // Luego validamos el día límite
    let isLimitDayValid = this.validateAdvanceLimitDay(Number(this.model.advanceLimitDay));
    // Ambos deben ser válidos
    return isInitialDayValid && isLimitDayValid;
  }


  validateAdvanceLimitAmount(value: number): boolean {
    if (!isNaN(value)) {
      if (Number.isInteger(value)) {
        value = parseFloat(value.toFixed(2));
      }
      return this.advanceLimitAmountValid;
    } else {
      this.advanceLimitAmountValid = false;
      return false;
    }
  }

  validateCustomButtonFields() {
    if (this.model.customRedirection && this.model.customRedirection.showButtonRedirection) {
      this.customButtonImageValid = this.model.customRedirection.image && this.model.customRedirection.image.length > 0;
      this.customButtonNameValid = this.model.customRedirection.name && this.model.customRedirection.name.length > 0;
      this.customButtonAndroidUrlValid = this.customButtonAndroidUrlRegex.test(this.model.customRedirection.androidUrl);
      this.customButtonIosUrlValid = this.customButtonIosUrlRegex.test(this.model.customRedirection.iosUrl);

      return this.customButtonImageValid && this.customButtonNameValid && this.customButtonAndroidUrlValid && this.customButtonIosUrlValid;
    } else {
      return true;
    }
  }

  validateField(field) {
    if (this.model[field + 'Text'] && this.model[field + 'Text'].length > 0 && this.model[field + 'Text'] !== null) {
      return true;
    } else {
      return false;
    }
  }



  checkFieldsNotEmptyCompany(): void {
    if (this.livesLicence) {
      if (this.model.hrValidators && this.model.hrValidators.length > 0 &&
        this.model.hrValidators[0] &&
        this.model.companyCode &&
        this.model.pushAcceptText && this.model.pushAcceptText.length > 0 &&
        this.model.pushDenyText && this.model.pushDenyText.length > 0 &&
        this.model.mailAcceptText && this.model.mailAcceptText.length > 0 &&
        this.model.mailDenyText && this.model.mailDenyText.length > 0 &&
        this.validateMyreportin() &&
        (this.hostelLicence ? this.model.holidayBagAllowed.toString() == 'true' ? this.model.holidayBagValidator !== null && this.model.holidayBagValidator !== undefined : true : true) &&
        (!this.advancesValidatorAllowed || this.validateBothAdvanceFields()) &&
        this.validateCustomButtonFields()) {
        if (this.isNew) {
          this.companyFormEdit = true;
        } else {
          let changes = this.getChangesCompany();
          if (Object.keys(changes).length > 0) {
            this.companyFormEdit = true;
          } else {
            this.companyFormEdit = false;
          }
        }
      } else {
        this.companyFormEdit = false;
      }
    } else if (this.conectiaLicence) {
      if (this.model.companyImageData && this.model.companyCode && this.validateMyreportin()) {
        this.companyFormEdit = true;
      } else {
        this.companyFormEdit = false;
      }
    } else {
      if (this.model.companyImageData && this.model.name && this.model.identifierNumber && this.validateMyreportin()) {
        this.companyFormEdit = true;
      } else {
        this.companyFormEdit = false;
      }
    }
  }


  /* SETTERS */

  setMyreportin(value: string) {
    this.model.myreportin = value;
    if (value != null) {
      this.validateMyreportin();
      this.checkFieldsNotEmptyCompany();
    }
  }

  setPushAccept(newValue: string): void {
    this.model.pushAcceptText = newValue;
    this.pushAcceptValid = this.validateField('pushAccept');
    this.checkFieldsNotEmptyCompany()
  }

  setPushReject(newValue: string): void {
    this.model.pushDenyText = newValue;
    this.pushRejectValid = this.validateField('pushDeny');
    this.checkFieldsNotEmptyCompany()
  }

  setMailAccept(newValue: string): void {
    this.model.mailAcceptText = newValue;
    this.mailAcceptValid = this.validateField('mailAccept');
    this.checkFieldsNotEmptyCompany()
  }

  setMailReject(newValue: string): void {
    this.model.mailDenyText = newValue;
    this.mailRejectValid = this.validateField('mailDeny');
    this.checkFieldsNotEmptyCompany()
  }

  setAdvanceInitialDay(newValue: string): void {
    let numberValue = Number(newValue);
    if (this.model.advanceInitialDay !== numberValue && this.validateAdvanceInitialDay(numberValue)) {
      this.model.advanceInitialDay = numberValue;
    }
    this.checkFieldsNotEmptyCompany();
  }

  setAdvanceLimitDay(newValue: string): void {
    let numberValue = Number(newValue);
    if (this.model.advanceLimitDay !== numberValue && this.validateAdvanceLimitDay(numberValue)) {
      this.model.advanceLimitDay = numberValue;

    }
    this.checkFieldsNotEmptyCompany();
  }

  setAdvanceLimitAmount(newValue: string): void {
    let numberValue = Number(newValue);
    if (this.model.advanceLimitAmount !== numberValue && this.validateAdvanceLimitAmount(numberValue)) {
      this.model.advanceLimitAmount = numberValue;
      this.checkFieldsNotEmptyCompany();
    }
  }

  setCompanyNameOffline(newValue: string): void {
    this.model.name = newValue;
    this.checkFieldsNotEmptyCompany();
  }

  setCompanyIdentifierNumberOffline(newValue: string): void {
    this.model.identifierNumber = newValue;
    this.checkFieldsNotEmptyCompany();
  }


  /* DROPDOWNS */

  companySelectedChanged(data: any) {
    if (data) {
      this.model.companyCode = data.companyCode;
      this.model.name = data.companyName;

      if (!this.livesLicence) {
        this.checkFieldsNotEmptyCompany()
      }
    }
  }

  /*  companySelectedPayRollDateTypeChanged(PayRollDateType: boolean) {
     if (String(PayRollDateType) !== 'undefined') {
       this.model.seniorityCompanyDate = PayRollDateType;
       this.checkFieldsNotEmptyCompany()
     }
   } */

  companySelectedHolidayBagAllowChanged(holidayBagAllow: boolean) {
    if (String(holidayBagAllow) !== 'undefined') {
      this.model.holidayBagAllowed = holidayBagAllow;
      this.holidayBagValidatorAllowed = holidayBagAllow.toString() === 'true' ? true : false;
      this.model.holidayBagValidator = holidayBagAllow.toString() !== 'true' ? null : this.model.holidayBagValidator;
      this.checkFieldsNotEmptyCompany()
    }
  }

  companySelectedAdvanceAllowChanged(advanceAllow: boolean) {
    if (String(advanceAllow) !== 'undefined') {
      this.model.advanceAllowed = advanceAllow;
      this.advancesValidatorAllowed = advanceAllow.toString() === 'true' ? true : false;
      this.model.advanceValidator = advanceAllow.toString() !== 'true' ? null : this.model.advanceValidator;
      this.checkFieldsNotEmptyCompany()
    }
  }

  companySelectedAutoInvitationsChanged(sendAutoInvite: boolean) {
    if (String(sendAutoInvite) !== 'undefined') {
      this.model.sendAutoInvite = sendAutoInvite;
      this.checkFieldsNotEmptyCompany()
    }
  }

  companySelectedNetUsersChanged(netUsers: [{}]) {
    if (netUsers) {
      this.model.netUsers = netUsers;
      // Filtrar `hrValidators`, eliminando IDs que ya no estén en `netUsers`
      this.model.hrValidators = this.model.hrValidators.filter(id => netUsers.includes(id));

      // Si `holidayBagValidator` ya no está en `netUsers`, lo ponemos en `null`
      if (this.model.holidayBagValidator && !netUsers.includes(this.model.holidayBagValidator)) {
        this.model.holidayBagValidator = null;
      }

      // Si `advanceValidator` ya no está en `netUsers`, lo ponemos en `null`
      if (this.model.advanceValidator && !netUsers.includes(this.model.advanceValidator)) {
        this.model.advanceValidator = null;
      }

      this.checkFieldsNotEmptyCompany();
    }
  }

  companySelectedHRValidatorChanged(hrValidators: [{}]) {
    if (hrValidators) {
      this.model.hrValidators = hrValidators;
    }
    this.checkFieldsNotEmptyCompany()
  }

  companySelectedHolidayBagValidatorChanged(holidayBagValidator: String) {
    if (holidayBagValidator) {
      this.model.holidayBagValidator = holidayBagValidator;
    }
    this.checkFieldsNotEmptyCompany()
  }

  companySelectedAdvanceValidatorChanged(advanceValidator: string) {
    if (advanceValidator) {
      this.model.advanceValidator = advanceValidator;
    }
    this.checkFieldsNotEmptyCompany()
  }

  /* MÉTODO PARA EL ENVIO DE DATOS */
  onSubmitCompany() {
    this.loading = true
    this.checkFieldsNotEmptyCompany();

    if (this.isNew) {
      if (this.conectiaLicence) {
        this._messageDialog.ShowLoading(`Sincronizando datos con Innuva, espere un momento`, `Creando ${this.model.name}`)
      } else {
        this._messageDialog.ShowLoading(`Creando...`, `Creando ${this.model.name}`)
      }

      if (!this.livesLicence) {
        this.model.advanceAllowed = false;
        this.model.customRedirection = {
          redirectionId: null,
          name: null,
          image: null,
          androidUrl: null,
          iosUrl: null,
          showButtonRedirection: false,
          imageDefault: null
        };
        this.model.holidayBagAllowed = false;
        this.model.mailAcceptText = null;
        this.model.mailDenyText = null;
        this.model.pushAcceptText = null;
        this.model.pushDenyText = null;
        this.model.sendAutoInvite = false;

      }

      if (!this.conectiaLicence) {

        this._companyService.createModelOffline(this.model).subscribe(
          result => {
            this.loading = false;
            this._messageDialog.ShowContinueMessage(`La empresa ${this.model.name} se ha creado correctamente.`, `Empresa ${this.model.name} creada correctamente`).
              then(() => {
                this._location.back();
              })
          },
          error => {
            this.loading = false;

            if (error.status === 409) {
              this._messageDialog.ShowAlert(`Hubo un error al crear ${this.model.name}, ya existe una empresa con el NIF/CIF ${this.model.identifierNumber}`, `Error al crear ${this.model.name}`)
            } else {
              this._messageDialog.ShowAlert(`Hubo un error al crear ${this.model.name}`, `Error al crear ${this.model.name}`)
            }
          }
        )

      } else if (!this.livesLicence) {
        this._companyService.createModelConnectia(this.model).subscribe(

          result => {
            this.loading = false;
            this._messageDialog.ShowContinueMessage(`La empresa ${this.model.name} se ha creado correctamente.`, `Empresa ${this.model.name} creada correctamente`).
              then(() => {
                this._location.back();
              })
          },
          error => {
            this.loading = false;
            console.error(error)
            if (this.conectiaLicence && this.livesLicence) {
              this._messageDialog.ShowAlert(`Hubo un error al crear ${this.model.name}, comprueba que la empresa tiene un organigrama, hay centros de trabajo para la empresa, hay centros de coste para la empresa, hay empleados para la empresa especificada. `, `Error al crear ${this.model.name}`)
            } else {
              this._messageDialog.ShowLoading(`Hubo un error al crear ${this.model.name}`, `Error al crear ${this.model.name}`)
            }
          }
        )
      } else {
        this._companyService.createModel(this.model).subscribe(

          result => {
            this.loading = false;
            this._messageDialog.ShowContinueMessage(`La empresa ${this.model.name} se ha creado correctamente.`, `Empresa ${this.model.name} creada correctamente`).
              then(() => {
                this._location.back();
              })
          },
          error => {
            this.loading = false;
            console.error(error)
            if (this.conectiaLicence && this.livesLicence) {
              this._messageDialog.ShowAlert(`Hubo un error al crear ${this.model.name}, comprueba que la empresa tiene un organigrama, hay centros de trabajo para la empresa, hay empleados para la empresa especificada. `, `Error al crear ${this.model.name}`)
            } else {
              this._messageDialog.ShowLoading(`Hubo un error al crear ${this.model.name}`, `Error al crear ${this.model.name}`)
            }
          }
        )
      }


    } else {

      let changes = this.getChangesCompany();
      
      // Hago los cambios de textos primero
      this._companyService.updateModel(this.model.company1, changes).subscribe(
        () => {
          // Si hay cambios de imágenes, manejar las actualizaciones

          let imageUpdateObservables = this.prepareImageUpdates(changes);

          // Si no hay actualizaciones de imágenes, mostrar mensaje de éxito
          if (imageUpdateObservables.length === 0) {
            this.loading = false;
            this.showMessage('Datos actualizados', 'Se han actualizado los datos correctamente');
          } else {
            // Esperar a que todas las actualizaciones de imágenes se completen
            forkJoin(imageUpdateObservables).subscribe(
              () => {
                // Todas las actualizaciones de imágenes fueron exitosas
                this.loading = false;
                this.showMessage('Datos actualizados', 'Se han actualizado todos los datos e imágenes correctamente');
              },
              error => {
                // Hubo un error en las actualizaciones de imágenes
                this.loading = false;
                console.error(error)
                this._messageDialog.ShowAlert('Error al enviar', 'Ha habido un error al actualizar las imágenes');
              }
            );
          }
        },
        error => {
          // Hubo un error en la actualización de configuración de entorno
          this.loading = false;
          console.error('error')
          console.error(error)
          this._messageDialog.ShowAlert('Error al enviar', 'Ha habido un error al actualizar los datos de configuración');
        }
      );
    }

  }



  /* SECCIONES Y ORGANIGRAMA */

  //construir JSON para organigrama 
  buildHierarchy(arr, parentId = null, level = 0) {

    const parent = arr.filter(item => item.parent === parentId);
    if (parent.length === 0) {
      return [];
    }

    return parent.map(child => {
      const {
        section1,
        name,

        validator,
        validatorName,
        validatorJobTitleName,
        validatorProfileImage,

        dualResponsible,
        dualResponsibleName,
        dualResponsibleProfileImage,
        dualResponsibleJobTitleName,

        delegateResponsible,
        delegateResponsibleName,
        delegateResponsibleProfileImage,
        delegateResponsibleJobTitleName,

        delegateResponsibleAllow,
        dualResponsibleAllow,
      } = child;



      const childHierarchy = this.buildHierarchy(arr, section1, level + 1);

      // Crear el objeto base
      const result = {
        id: section1,
        area: name,
        validator: validator,
        validatorName: validatorName,
        validatorPosition: validatorJobTitleName,
        validatorProfileImage: validatorProfileImage,
        delegateResponsibleAllow: delegateResponsibleAllow,
        delegateResponsible: delegateResponsible,
        delegateResponsibleName: undefined,
        delegateResponsibleProfileImage: undefined,
        delegateResponsiblePosition: undefined,
        dualResponsibleAllow: dualResponsibleAllow,
        dualResponsible: dualResponsible,
        dualResponsibleName: undefined,
        dualResponsibleProfileImage: undefined,
        dualResponsiblePosition: undefined,
        isOpen: level < 1,  // isOpen será true solo en los dos primeros niveles
        children: undefined,
      };



      // Añadir los campos condicionales
      if (delegateResponsibleAllow) {
        result.delegateResponsibleName = delegateResponsibleName;
        result.delegateResponsiblePosition = delegateResponsibleJobTitleName;
        result.delegateResponsibleProfileImage = delegateResponsibleProfileImage;
      }

      if (dualResponsibleAllow) {
        result.dualResponsibleName = dualResponsibleName;
        result.dualResponsiblePosition = dualResponsibleJobTitleName;
        result.dualResponsibleProfileImage = dualResponsibleProfileImage;
      }

      // Añadir children si hay algún hijo
      if (childHierarchy.length > 0) {
        result.children = childHierarchy;
      }

      return result;
    });
  }

  async updateAndShowLoadingSpinner({ innuvaSync = false, firstLoad = false }: { innuvaSync?: boolean, firstLoad?: boolean }, event?: Event) {
    if (event) {
      event.preventDefault();
    }

    this.showLoadingSpinner = true;
    this.showLoadingInnuvaSpinner = innuvaSync ? true : false;
    this.showOrgChart = false;
    firstLoad ? this.getSections() : await this.syncSections();
    this.clearSelectedSection();
    setTimeout(() => {

      // Actualizar la fecha de la última actualización
      const currentDate = new Date();
      const formattedDate = currentDate.toLocaleString('es-ES', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      });

      this.lastUpdateDate = formattedDate.replace(/-/g, '/').replace(',', ', ');

      // Ocultar la rueda de carga y mostrar el organigrama nuevamente
      this.showLoadingSpinner = false;
      this.showLoadingInnuvaSpinner = false;
      this.showOrgChart = true;
    }, 1000);
  }

  openPDF() {
    const url = "https://www.liveshr.com/wp-content/uploads/2024/12/Explicacion-de-organigrama_LivesHR.pdf";
    window.open(url, "_blank");
  }


  clearSelectedSection() {
    // Resetear la sección a su estado inicial
    this.section = new AppSeccion();
    this.isSectionSelected = false;
    this.isCompanySelectedDelegatedValidatorReadOnly = true;
    this.isCompanySelectedDoubleValidatorReadOnly = true;

    this.sectionModel = {};
    this.section.section1 = null;
    this.section.delegateResponsibleAllow = null;
    this.section.dualResponsibleAllow = null;
    this.section.validator = null;
    this.section.delegateResponsible = null;
    this.section.dualResponsible = null;
  }

  getSections() {

    this.loading = true;

    this._sectionsService.getAllModelsByCompany(this.companyId).subscribe((response: AppSeccion[]) => {
      if (response) {
        const transformed = this.buildHierarchy(response);
        this.orgData = transformed[0];
      }
      this.loading = false;
    }, error => {
      this.loading = false;
      console.error(error)
    });
  }

  syncSections(): Promise<void> {
    return new Promise((resolve, reject) => {
      this._sectionsService.syncModel(this.companyId).subscribe(
        (response: AppSeccion[]) => {
          if (response) {
            const transformed = this.buildHierarchy(response);
            this.orgData = transformed[0];
          }
          resolve();
        },
        (error) => {
          console.error('syncSections', error);
          reject(error);
        }
      );
    });
  }


  handleEditEvent(selectedSsection: ISection): void {

    //enviar Ids a los dropdown de seccion
    this.section.section1 = selectedSsection.id;
    this.section.validator = selectedSsection.validator;
    this.section.validatorName = selectedSsection.validatorName;
    this.section.delegateResponsibleAllow = selectedSsection.delegateResponsibleAllow !== null ? selectedSsection.delegateResponsibleAllow.toString() : null;
    this.section.dualResponsibleAllow = selectedSsection.dualResponsible !== null ? selectedSsection.dualResponsibleAllow.toString() : null;
    this.section.delegateResponsible = selectedSsection.delegateResponsible !== null ? selectedSsection.delegateResponsible : '-1';//BORRAR SELECCION SI ES NULO
    this.section.dualResponsible = selectedSsection.dualResponsible !== null ? selectedSsection.dualResponsible : '-1';//BORRAR SELECCION SI ES NULO;
    this.companySelectedValidatorChanged(selectedSsection.validator)


    this.companySelectedDelegateValidationChanged(selectedSsection.delegateResponsibleAllow)
    this.companySelectedDoubleValidationChanged(selectedSsection.dualResponsibleAllow)
    this.companySelectedDelegateValidatorChanged(selectedSsection.delegateResponsible)
    this.companySelectedDoubleValidatorChanged(selectedSsection.dualResponsible)

    this.focusSection();//scroll a seccion
    this.originalModelSections = selectedSsection;

  }

  focusSection() {
    const element = document.getElementById('focusSection');

    if (element) {
      // Calcular la altura de la ventana y la posición del elemento
      const viewportHeight = window.innerHeight;
      const elementRect = element.getBoundingClientRect();
      const elementPosition = elementRect.top;

      // Calcula la posición de scroll para centrar el elemento
      const offset = elementPosition - (viewportHeight / 2) + (elementRect.height / 2);

      // Desplazarse a la posición calculada
      window.scrollTo({
        top: window.scrollY + offset,
        behavior: 'smooth'
      });
    }

  }

  newFeatureAlert() {

    this.showMessage('Funcionalidad próximamente disponible', 'Esta funcionalidad estará disponible próximamente');
  }

  //Funcion para uscar el id en el objeto de persona previemente convertido a json 
  findObjectById(obj, id) {
    // Si el objeto actual tiene el id que buscamos, retornamos el objeto
    if (obj.id === id) {
      return obj;
    }

    // Si el objeto tiene hijos, iteramos a través de ellos
    if (Array.isArray(obj.children)) {
      for (let i = 0; i < obj.children.length; i++) {
        const found = this.findObjectById(obj.children[i], id);
        if (found) {
          return found;
        }
      }
    }

    // Si no encontramos el objeto, retornamos null
    return null;
  }

  companySelectedSectionChanged(selectedSection: string) {


    this.isSectionSelected = true;


    this.loading = true;

    //Guardo el modelo de la sección seleccionada
    this._sectionsService.getAllModelsByCompany(this.companyId).subscribe((response: AppSeccion[]) => {
      if (response) {
        const index = response.findIndex(item => item.section1 === selectedSection);
        this.sectionModel = response[index]
      }
      this.loading = false;
    }, error => {
      this.loading = false;
      console.error(error)
    });


    var valorJSON = JSON.parse(JSON.stringify(this.orgData))
    this.handleEditEvent(this.findObjectById(valorJSON, selectedSection)) //establezco los datos

  }

  companySelectedValidatorChanged(validator: string) {

    this.section.validator = validator;
    this.checkFieldsNotEmptySections();
  }

  companySelectedDelegateValidationChanged(delegateValidation: boolean) {


    if (delegateValidation && delegateValidation.toString() == 'false') {
      this.isCompanySelectedDelegatedValidatorReadOnly = true;
      //inicializo el validador delegado
      this.companySelectedDelegateValidatorChanged(null)
    } else {
      this.isCompanySelectedDelegatedValidatorReadOnly = false;
    }

    this.section.delegateResponsibleAllow = delegateValidation ? delegateValidation.toString() : "false";
    this.checkFieldsNotEmptySections();

  }

  companySelectedDoubleValidationChanged(doubleValidation: boolean) {

    if (doubleValidation && doubleValidation.toString() == 'false') {
      this.isCompanySelectedDoubleValidatorReadOnly = true;
      //inicializo el validador doble
      this.companySelectedDoubleValidatorChanged(null)
    } else {
      this.isCompanySelectedDoubleValidatorReadOnly = false;
    }

    this.section.dualResponsibleAllow = doubleValidation ? doubleValidation.toString() : "false";
    this.checkFieldsNotEmptySections();

  }

  companySelectedDelegateValidatorChanged(delegateValidator: string) {

    this.section.delegateResponsible = delegateValidator;
    this.checkFieldsNotEmptySections();

  }

  companySelectedDoubleValidatorChanged(doubleValidator: string) {

    this.section.dualResponsible = doubleValidator;
    this.checkFieldsNotEmptySections();
  }

  checkFieldsNotEmptySections(): void {

    let delegate = true
    let dual = true

    if (!this.section.section1) {
      delegate = false;
      dual = false;
    }

    if (this.section.delegateResponsibleAllow == 'true' && (this.section.delegateResponsible == null || this.section.delegateResponsible == '-1')) {
      delegate = false;
    }

    if (this.section.dualResponsibleAllow == 'true' && (this.section.dualResponsible == null || this.section.dualResponsible == '-1')) {
      dual = false;
    }

    if (delegate && dual) {

      let changes = this.getChangesSections();

      if (Object.keys(changes).length > 0) {

        this.sectionsFormEdit = true;
      } else {
        this.sectionsFormEdit = false;
      }

    } else {
      this.sectionsFormEdit = false;

    }


  }

  onSubmitSections() {
    this.checkFieldsNotEmptySections();
    if (this.sectionsFormEdit) {
      let changes = this.getChangesSections();
      this._sectionsService.updateModel(this.section.section1, changes).subscribe(
        () => {
          this.sectionsFormEdit = false;
          this.showMessage('Datos actualizados', 'Se han actualizado los datos de la sección correctamente');
          this.updateAndShowLoadingSpinner({});
        },
        error => {
          // Hubo un error en la actualización de configuración de entorno
          console.error(error)
          this.showError('Error al enviar', 'Ha habido un error al actualizar los datos de la sección');
        }
      );
    }
  }


  /* SMTP */
  /* HANDLERS */
  handleTestSmtp() {
    this._messageDialog.ShowSMTPTestMessage(
      'Escribe el email donde recibirás la prueba',
      'Probar SMTP'
    )
      .then(result => {

        let dataToSend = {
          toEmail: result.value,
          fromEmail: null
        };

        if (!this.checkSmtpChecked) {
          dataToSend = {
            ...dataToSend,
            tlsSsl: true,
            fromEmail: this.smtpModel.user,
            ...this.smtpModel
          };
        } else {
          dataToSend = {
            toEmail: dataToSend.toEmail,
            fromEmail: null
          }
        }
        this._smtpServerService.testSMTP(dataToSend).subscribe(
          (result: any) => {
            this._messageDialog.ShowMessage(
              `Se ha enviado un email de prueba a ${dataToSend.toEmail}`,
              'Email enviado'
            );
          },
          (error) => {
            console.error(error)
          }
        )

      });
  }

  handleEnableChange(value: any) {
    this.checkFieldsNotEmptySmtpServer()
  }


  ////////////////

  togglePasswordVisibility(): void {
    if (!this.smtpModel.enable) {
      this.showPassword = !this.showPassword;
    }
  }

  setSmtpOut(newValue: string): void {
    this.smtpModel.outServer = newValue;
    this.outServerValid = this.validateSmtpField('outServer');
    this.checkSmtpButtonEnabled = this.checkSMTPAllValidFields();
    this.checkFieldsNotEmptySmtpServer();
  }

  setSmtpOutPort(newValue: string): void {
    let textToNumber = Number(newValue)
    if (textToNumber.toString() == 'NaN') {
      this.smtportPortValid = false;
    } else {
      this.smtpModel.outServerPort = Number(newValue);
      this.smtportPortValid = true;
    }

    this.outServerPortValid = this.validateSmtpField('outServerPort');
    this.checkSmtpButtonEnabled = this.checkSMTPAllValidFields();
    this.checkFieldsNotEmptySmtpServer()

  }

  setSmtpMail(newValue: string): void {
    this.smtpModel.user = newValue;

    this.userValid = this.validateSmtpField('user');
    this.checkSmtpButtonEnabled = this.checkSMTPAllValidFields();
    this.checkFieldsNotEmptySmtpServer()
  }

  setSmtpPass(newValue: string): void {
    this.smtpModel.password = newValue;

    this.passwordValid = this.validateSmtpField('password');
    this.checkSmtpButtonEnabled = this.checkSMTPAllValidFields();
    this.checkFieldsNotEmptySmtpServer()
  }



  /* VALIDACIONES */
  validateSmtpField(field) {

    switch (field) {
      case 'outServer':
        let outServerValidation = this.smtpModel && this.smtpModel.outServer && this.smtpModel.outServer !== '';
        return outServerValidation

      case 'outServerPort':
        let outServerPortValidation = this.smtpModel && this.smtpModel.outServerPort && !isNaN(this.smtpModel.outServerPort);
        return outServerPortValidation
      case 'user':
        let userValidation = this.smtpModel && this.smtpModel.user && /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(this.smtpModel.user);
        return userValidation
      case 'password':
        let passwordValidation = this.smtpModel && this.smtpModel.password && this.smtpModel.password !== '';
        return passwordValidation
      // Agrega más casos según sea necesario
      default:
        return true
    }
  }

  checkFieldsNotEmptySmtpServer(): void {

    if (this.checkSmtpChecked) {
      this.smtpFormEdit = true;
      return
    }

    if (this.smtpModel.outServer && this.smtpModel.outServer.length > 0 && this.smtpModel.outServerPort && this.smtpModel.outServerPort.toString().length > 0 && this.smtpModel.user && this.smtpModel.user.length > 0 && this.smtpModel.password && this.smtpModel.password.length > 0 && this.smtportPortValid) {
      let changes = this.getChangesSmtpServer();
      if (Object.keys(changes).length > 0) {
        this.smtpFormEdit = true;
      } else {
        this.smtpFormEdit = false;
      }

    } else {
      this.smtpFormEdit = false;
    }
  }

  checkSMTPAllValidFields(): boolean {
    if (this.outServerValid && this.outServerPortValid && this.userValid && this.passwordValid) {
      return true

    } else {

      return false

    }
  }


  // Mejora y optimización del método onSubmitSmtp()
  onSubmitSmtp() {
    // Primero, aseguramos que los campos requeridos estén llenos.
    this.checkFieldsNotEmptySmtpServer();

    // Preparamos los datos comunes para crear o actualizar la configuración SMTP.
    const smtpData = {
      smtpServerData: {
        smtpServer1: this.smtpModel.smtpServer1, // Directamente asignamos el valor, la lógica de null se manejará en el backend si es necesario.
        outServer: this.smtpModel.outServer,
        outServerPort: this.smtpModel.outServerPort,
        tlsSsl: true,
        user: this.smtpModel.user,
        password: this.smtpModel.password,
        enable: true
      }
    };

    // Determinamos si se debe crear, actualizar o eliminar la configuración basándonos en la lógica del negocio.
    if (this.smtpFormEdit) {
      if (this.checkSmtpChecked) {
        // Si se seleccionó la opción de eliminar la configuración SMTP.
        this.deleteSmtpConfiguration();
      } else {
        // Crear o actualizar la configuración SMTP.
        this.createOrUpdateSmtpConfiguration(smtpData);
      }
    }
  }

  // Método para eliminar la configuración SMTP.
  deleteSmtpConfiguration() {
    this._smtpServerService.deleteSMTP(this.smtpModel.smtpServer1).subscribe(
      results => {
        this.resetForm();
        this.showMessage('Datos actualizados', 'Se han actualizado los datos de notificaciones de solicitudes correctamente');
      },
      error => {
        console.error(error);
        this.showError('Error al enviar', 'Ha habido un error al actualizar los datos de notificaciones de solicitudes');
      }
    );
  }

  // Método para crear o actualizar la configuración SMTP.
  createOrUpdateSmtpConfiguration(data) {
    this._companyService.updateModel(this.model.company1, data).subscribe(
      results => {
        this.showMessage('Datos actualizados', 'Se han actualizado los datos de notificaciones de solicitudes correctamente');
      },
      error => {
        console.error(error);
        this.showError('Error al enviar', 'Ha habido un error al actualizar los datos de notificaciones de solicitudes');
      }
    );
  }

  // Método para restablecer el formulario.
  resetForm() {
    this.smtpFormEdit = false;
    this.smtpModel = new AppSmtp();
    this.originalModelSmtp = new AppSmtp();
  }


  // Preparar y obtener un array de observables para las actualizaciones de imágenes
  prepareImageUpdates(changes: any): Observable<any>[] {
    let imageUpdateObservables = [];
    const { companyImageData, companyStampData } = changes;
    if (companyImageData) {
      imageUpdateObservables.push(this._imagesService.updateModel(companyImageData.image, companyImageData));
    }
    if (companyStampData) {
      imageUpdateObservables.push(this._imagesService.updateModel(companyStampData.image, companyStampData));
    }

    // Limpia las propiedades que ya no son necesarias en el objeto de cambios
    delete changes.imageData;
    delete changes.stampData;

    return imageUpdateObservables;
  }

  // Método genérico para mostrar mensajes
  showMessage(title: string, message: string) {
    this._messageDialog.ShowMessage(message, title);
    this.companyFormEdit = false;
  }

  showAlert(title: string, message: string) {
    this._messageDialog.ShowAlert(message, title);
    this.companyFormEdit = false;
  }

  showError(title: string, message: string) {
    this._messageDialog.ShowAlert(message, title);
    this.companyFormEdit = false;
  }

  /* REQUERIDOS POR EL FORMULARIO BASE */
  afterModelLoad(): void {
  }

  afterModelUpdated(): void {
  }

  getModelInstance(): AppEmpresas {
    return new AppEmpresas();
  }
  ngOnChanges(changes: SimpleChanges): void {
  }
  afterModelCreated(success: boolean): void {
  }
}

